import React, { useMemo } from 'react';

import { getIconColorForBackgroundColor } from 'flow/editor/components/helpers';
import { useAppSelector } from '~/store/reduxHooks';
import { selectFirstTagNodeId } from 'flow/store/redux/selectors';

import BaseNode from '../BaseNode';
import { StyledIconWrapper } from './styles';
import type { TagNode as ITagNode, WorkflowNodeProps } from 'flow/service/graph/nodes/types';
import { getTagNodeIcon } from './helpers';


function TagNode(props: WorkflowNodeProps<ITagNode>) {
  const {
    id,
    type,
    data: {
      color, isCaseGenerating, label, hasOutcomes,
    },
  } = props;

  const firstTagNodeId = useAppSelector(selectFirstTagNodeId);
  const isFirstTagNode = firstTagNodeId === id;

  const iconColor = getIconColorForBackgroundColor(color);
  const TagIcon = useMemo(() => getTagNodeIcon({
    hasOutcomes,
    iconColor,
    isCaseGenerating,
  }), [hasOutcomes, iconColor, isCaseGenerating]);

  return (
    <BaseNode
      icon={(
        <StyledIconWrapper
          {...(isFirstTagNode && { 'data-pendo-anchor': 'evaluation-explainability-tag-node' })}
          backgroundColor={color}
        >
          {TagIcon}
        </StyledIconWrapper>
      )}
      id={id}
      label={label}
      stateStyle={{
        baseBackgroundColor: 'var(--cl-gray-300)',
        highlighted: {
          backgroundColor: 'var(--cl-gray-400)',
        },
        hovered: {
          backgroundColor: 'var(--cl-gray-400)',
        },
      }}
      type={type}
    />
  );
}

export default React.memo(TagNode);
